import PreviewImageDescription from './PreviewImageDescription';



export default PreviewImageDescription;
